import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Article from "@/pages/article/page";
import About from "@/pages/about/page";
import ScrollToTop from "@/components/feature/ScrollToTop";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <Home />
      </>
    ),
  },
  {
    path: "/category/:id",
    element: (
      <>
        <ScrollToTop />
        <Category />
      </>
    ),
  },
  {
    path: "/article/:id",
    element: (
      <>
        <ScrollToTop />
        <Article />
      </>
    ),
  },
  {
    path: "/about",
    element: (
      <>
        <ScrollToTop />
        <About />
      </>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;